import React, { useEffect, useRef } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const CustomMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const loader = new Loader({
      apiKey: 'AIzaSyCOa-Vx3796Zb7OSqUu9qknCyKPwDY6H28',
      version: 'weekly',
    });

    loader.load().then(() => {
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat: 40.90982, lng: 14.39379 }, // Our location
        zoom: 17,
        mapTypeId: 'roadmap',
        mapId: 'DEMO_MAP_ID',
      });

      new window.google.maps.Marker({
        position: { lat: 40.90982, lng: 14.39379 },
        map,
        title: 'Te.c.h-e.',
        label: {
          text: 'Te.c.h-e.',
          color: '#000000',
          fontWeight: 'bold',
          fontSize: '14px',
        },
        icon: {
          path: window.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
          scale: 5,
          fillColor: '#324B8E',
          fillOpacity: 1,
          strokeWeight: 1,
          strokeColor: '#000',
        },
      });
    });
  }, []);

  return <div ref={mapRef} style={{ height: '450px', width: '100%', border: '2px solid black' }} />;
};

export default CustomMap;
